module.exports = __webpack_public_path__ + "static/media/2.5733f0e7.jpg";